module.exports = __webpack_public_path__ + "static/media/4.Wet and Dry Vaccum Cleaner.ec2071f7.jpg";